var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgScheduledIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H16C18.2091 0 20 1.79086 20 4V16C20 18.2091 18.2091 20 16 20H4C1.79086 20 0 18.2091 0 16V4Z",
    fill: "#ECF3F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 15C7.23857 15 5 12.7614 5 10C5 7.23857 7.23857 5 10 5C12.7614 5 15 7.23857 15 10C15 12.7614 12.7614 15 10 15ZM10 14C12.2092 14 14 12.2092 14 10C14 7.79086 12.2092 6 10 6C7.79086 6 6 7.79086 6 10C6 12.2092 7.79086 14 10 14ZM10.5 10H12.5V11H9.5V7.5H10.5V10Z",
    fill: "#0F4A43"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgScheduledIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ScheduledIcon.3ced05ec.svg";
export { ForwardRef as ReactComponent };